/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import vuetify from './vuetify'
import pinia from '@/store'
import router from '@/router'
import i18n from './i18n'
import { registerSentry } from './sentry'
import { isDev } from '@/utils/environment'

// Types
import type { App } from 'vue'

export function registerPlugins(app: App) {
  if (!isDev) registerSentry(app, router)
  app.use(vuetify).use(router).use(pinia).use(i18n)
}
